import React from 'react'
import { Navigate } from 'react-router-dom'
import type { AppFeature } from '@hotel/shared'
import { useAuth } from '../contexts/AuthContextCore'
import { NoHotelAccess } from './NoHotelAccess'

interface ProtectedRouteProps {
  children: React.ReactNode
  roles?: string[]
  feature?: AppFeature
  /**
   * When true, only requires an authenticated user and skips the hotel-access
   * gate. Used by the onboarding route (which is the destination for users with
   * no hotel access, so it must not redirect to itself).
   */
  authOnly?: boolean
}

export function ProtectedRoute({ children, roles, feature, authOnly }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (authOnly) {
    return <>{children}</>
  }

  // Check if user has access to any hotels
  return <NoHotelAccess roles={roles} feature={feature}>{children}</NoHotelAccess>
}
